import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  headerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  headerTextBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  headerText: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "20px",
    color: "#272525",
  },
  headerCount: {
    borderRadius: "50%",
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontWeight: "600",
    fontSize: "14px",
    userSelect: "none",
  },
  closeIcon: {
    height: "25px",
    width: "25px",
    cursor: "pointer",
  },
  contentBox: {
    height: "60vh",
    overflowY: "scroll",
  },
}));

export default useStyles;
